module.exports = __webpack_public_path__ + "img/vat-restitution.50503116.svg";